module.exports = __webpack_public_path__ + "img/1963.d8e058fd.jpg";